import React, { useState, useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
import HeaderPage from "../HeaderPage";
import Sidebar from "../Sidebar";
import ProposalGenerator from "./form";
const Proposal = () => {


  return (
    <div className="flex-dashboard">

      <Sidebar elementoAtivo="proposal" defaultCollapsed={true} />
      <main>
        <HeaderPage nomeOpcao="Gerador de Propostas" />
        <div className="main-content">
          <ProposalGenerator />
        </div>
      </main>
    </div>
  );
};

export default Proposal;
